/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_ArmorInputs */

const en_svtag_armor = /** @type {(inputs: Svtag_ArmorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ARMOR`)
};

const ar_svtag_armor = /** @type {(inputs: Svtag_ArmorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#دروع`)
};

const bn_svtag_armor = /** @type {(inputs: Svtag_ArmorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ARMOR`)
};

const de_svtag_armor = /** @type {(inputs: Svtag_ArmorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ARMOR`)
};

const es_svtag_armor = /** @type {(inputs: Svtag_ArmorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ARMOR`)
};

const fr_svtag_armor = /** @type {(inputs: Svtag_ArmorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ARMOR`)
};

const pt_svtag_armor = /** @type {(inputs: Svtag_ArmorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ARMOR`)
};

const zh_svtag_armor = /** @type {(inputs: Svtag_ArmorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ARMOR`)
};

const tr_svtag_armor = /** @type {(inputs: Svtag_ArmorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ARMOR`)
};

const ru_svtag_armor = /** @type {(inputs: Svtag_ArmorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ARMOR`)
};

const pl_svtag_armor = /** @type {(inputs: Svtag_ArmorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ARMOR`)
};

/**
* | output |
* | --- |
* | "#ARMOR" |
*
* @param {Svtag_ArmorInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_armor = /** @type {((inputs?: Svtag_ArmorInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_ArmorInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_armor(inputs)
	if (locale === "bn") return bn_svtag_armor(inputs)
	if (locale === "de") return de_svtag_armor(inputs)
	if (locale === "es") return es_svtag_armor(inputs)
	if (locale === "fr") return fr_svtag_armor(inputs)
	if (locale === "pt") return pt_svtag_armor(inputs)
	if (locale === "zh") return zh_svtag_armor(inputs)
	if (locale === "tr") return tr_svtag_armor(inputs)
	if (locale === "ru") return ru_svtag_armor(inputs)
	if (locale === "pl") return pl_svtag_armor(inputs)
	return en_svtag_armor(inputs)
});